export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Erro de inicialização",
    "StaticConfigLoader.caption.init": "Inicialização",
    "StaticConfigLoader.text.init": "A inicializar a aplicação...",
    "StaticConfigLoader.error.settings": "Não é possível carregar as definições do site",
    "StaticConfigLoader.error.circuits": "Não é possível carregar a configuração dos serviços",
    //app
    "Legal.Localization": "pt",
    "AchievementApp.Navbar.storeTitle": "Loja",
    "AchievementApp.Navbar.supportTitle": "Apoio ao Cliente",
    "Legal.TermsConditions": "Termos e condições",
    "Legal.TermsService": "Termos de Serviço",
    "Legal.PrivacyPolicy": "Política de Privacidade",
    "Legal.CookiesPolicy": "Definições de Cookies",
    "Legal.Copyright": "Todas as marcas registadas, logotipos e nomes de marcas são propriedade dos respetivos donos.",
    "AchievementApp.Navbar.achievement": "Conquistas pessoais",
    "AchievementApp.Navbar.userAchievement": "Conquistas do utilizador",
    "AchievementApp.Navbar.settingsLink": "Definições",
    "AchievementApp.Navbar.profileLink": "Perfil",
    "AchievementApp.Navbar.reloginLink": "Volte a iniciar sessão ou altere a conta",
    "AchievementApp.Navbar.pageTitlePrew": "Conquistas ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Concluído",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtrar por títulos",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Os meus amigos",
    "UserFriendsList.heading.showMore": "Mostrar mais",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Deve configurar a autorização de dois fatores",
    "LimitedAccountPanel.2step.link": "Mais informações sobre a autorização de dois fatores",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Deve confirmar o seu endereço de e-mail",
    "LimitedAccountPanel.email.link": "Continuar para o perfil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "A sua conta está limitada devido a:",
    "LimitedAccountPanel.conclusion": "Depois de alterar as definições de segurança, deve terminar sessão e voltar a iniciar sessão, para que as alterações entrem em vigor",
    "LimitedAccountPanel.relogin": "Voltar a iniciar sessão",
    "EmailVerificationStateIcon.success": "Conta confirmada, e-mail verificado",
    "EmailVerificationStateIcon.warning": "Conta não confirmada, e-mail não verificado",
    "EmailVerificationStateIcon.danger": "Conta não confirmada, verificação de e-mail NECESSÁRIA",
    "TwoFactorStateIcon.success": "Conta protegida por autorização de dois fatores",
    "TwoFactorStateIcon.warning": "Conta não protegida, autorização de dois fatores desativada",
    "TwoFactorStateIcon.danger": "Autorização de dois fatores NECESSÁRIA",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Guardar definições",
    "UserSettingDialog.settings": "Definições",
    "UserSettingDialog.userSettings": "Definições do utilizador",
    "UserSettingDialog.language": "Idioma",
    "UserSettingDialog.privacy": "Privacidade",
    "UserSettingDialog.allUsers": "Todos os utilizadores",
    "UserSettingDialog.friendsOnly": "Apenas amigos",
    "UserSettingDialog.onlyMe": "Apenas eu",
    "UserSettingDialog.whoCanView": "Quem pode ver as minhas conquistas",
    //unlockProgress
    "ViewUnlockProgress.of": " de ",
    "ViewUnlockProgress.achievCompleted": " conquistas concluídas",
    "ViewUnlockProgress.myUnlock": "As Minhas Conquistas",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Introduza a alcunha a pesquisar",
    "ViewItemSearch.label.search": "Pesquisar utilizadores",
    "ViewItemSearch.resultNotFound": "Utilizador não encontrado",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Conquista",
    "ViewItemSearch.stub.empty": "Sem conquistas",
    "ViewItemSearch.stub.emptyCompare_1": "O utilizador ",
    "ViewItemSearch.stub.emptyCompare_2": " não tem conquistas neste jogo",
    "ViewItemSearch.limitedAccess": "O acesso às conquistas do utilizador selecionado é limitado",
    "ViewItemSearch.heading.selectGame": "Selecione o jogo na lista",
    "ViewItemSearch.globalstat.opened": "desbloqueada por ",
    "ViewItemSearch.globalstat.ofGamers": "% dos jogadores",
    //authentication
    "NotAllowedMessage.caption": "Não permitido",
    "NotAllowedMessage.body.h1": "O acesso às conquistas",
    "NotAllowedMessage.body.h3": "não é atualmente permitido para a sua conta",
    "NotAllowedMessage.relogin": "Alterar conta",
    "LandingMessage.caption": "Autenticação",
    "LandingMessage.body": "A concluir carregamento...",
    "TokenExpiredMessage.caption": "A autenticação expirou",
    "TokenExpiredMessage.body.h3": "Para continuar, volte a iniciar sessão",
    "TokenExpiredMessage.relogin": "Voltar a iniciar sessão",
    "AuthErrorMessage.caption": "A autenticação falhou",
    "AuthErrorMessage.body.h1": "Falha ao verificar a autenticação",
    "AuthErrorMessage.body.code": "Código",
    "AuthErrorMessage.body.desc": "Para continuar, volte a iniciar sessão",
    "AuthErrorMessage.relogin": "Voltar a iniciar sessão",
    "AuthorizationRequiredMessage.caption": "Autenticação necessária",
    "AuthorizationRequiredMessage.body.h3.1": "Está prestes a entrar em",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Mas precisa de autorização para prosseguir",
    "AuthorizationRequiredMessage.login": "Inicie sessão com Gaijin.net",
    "CheckingAuthMessage.caption": "Autenticação",
    "CheckingAuthMessage.body": "A verificar a autenticação, aguarde",
    "AuthorizationRequiredMessageMobile.body.h3.1": "A versão móvel está temporariamente indisponível",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Por favor, utilize a versão para computador",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Lamentamos",
}